export const COOKIE_POLICY_CONTENT = [
    {
        heading: "Background",
        content:
            "Energy Networks Association ('ENA', 'we' or 'us'), use cookies on the Connect Direct Platform (the 'Website'), which help us to improve your experience of the Website and to ensure that it performs as you expect it to. Cookies are text files containing small amounts of information, which are downloaded to your computer or mobile device by websites that you visit. They can improve your experience of using a website, for example, by remembering your preference settings and tracking your use of a website so that it can be improved to meet your needs.",
    },
    {
        heading: "Consent",
        content:
            "Websites must get consent to send cookies to your computer or mobile device unless the cookies are strictly necessary to provide services to you.",
    },
    {
        heading: "Cookies we use",
        content:
            "There are four different types of cookies (strictly necessary, performance, functionality, and targeting) which are explained below. Cookies can also be 'persistent' or session cookies.",
        bullets: [
            "Persistent cookies remain on your device between browsing sessions. They are activated each time you visit the website that created that particular cookie. For example, where a 'persistent cookie' is used on a website to remember your log-in details, you will not need to enter those details each time you visit that website.",
            "Session cookies allow website operators to link the actions of a user during a browser session. A browser session starts when you open the browser window and finishes when you close the browser window. Session cookies are created temporarily. Once you close the browser, all session cookies are deleted.",
        ],
    },
    {
        heading: "Strictly necessary",
        content: "On our Website we use strictly necessary cookies only. ",
    },
    {
        content:
            "Strictly necessary cookies are essential to enable you to receive a service on a website. For example, cookies to operate online shopping baskets, do your internet banking or to comply with the law (e.g. such as to keep your information safe). We would not be able to operate our website without using the 'strictly necessary' cookies listed below.",
        table: {
            headers: [
                "Cookie",
                "Description",
                "Persistent/ Session",
                "More Information",
            ],
            rows: [
                "cf_clearance",
                "Clearance Cookie stores the proof of challenge passed. It is used to no longer issue a challenge if present. It is required to reach an origin server.",
                "Persistent",
                "The storage duration is dependent on the end-users browser settings.",
            ],
        },
    },
    {
        content:
            "Cognito_Client_Id: also known as an App Client ID, is a unique identifier associated with an App Client in Amazon Cognito User Pools. Cognito_Username: is a unique identifier for a user in a user pool. Please note these values will be unique and updated based on the user's session.",
        table: {
            headers: ["Cookie", "Description", "Persistent/ Session"],
            rows: [
                "CognitoIdentityServiceProvider.{Cognito_Client_Id}.{Cognito_Username}.accessToken",
                "The accessToken is a token that is issued by Amazon Cognito when a user successfully authenticates. This token contains claims about the identity of the authenticated user and can be used to grant access to resources. This token allows for access to a specific user in AWS Cognito User Pool.",
                "Persistent",
            ],
        },
    },
    {
        table: {
            headers: ["Cookie", "Description", "Persistent/ Session"],
            rows: [
                "CognitoIdentityServiceProvider.{Cognito_Client_Id}.{Cognito_Username}.clockDrift",
                "Manages the discrepancy of system time between different servers or systems. In the context of authentication, it might be used to account for small differences in system time when comparing timestamps, such as the expiration time of a token.",
                "Persistent",
            ],
        },
    },
    {
        table: {
            headers: ["Cookie", "Description", "Persistent/ Session"],
            rows: [
                "CognitoIdentityServiceProvider.{Cognito_Client_Id}.{Cognito_Username}.idToken",
                "The idToken is a part of the session object that Cognito returns when a user successfully logs in. It contains claims about the identity of the authenticated user such as name, email, and etc.",
                "Persistent",
            ],
        },
    },
    {
        table: {
            headers: ["Cookie", "Description", "Persistent/ Session"],
            rows: [
                "CognitoIdentityServiceProvider.{Cognito_Client_Id}.{Cognito_Username}.refreshToken",
                "The refreshToken is a part of the session object that Cognito returns when a user successfully logs in. It is used to obtain new ID and access tokens after the original ones have expired.",
                "Persistent",
            ],
        },
    },
    {
        table: {
            headers: ["Cookie", "Description", "Persistent/ Session"],
            rows: [
                "CognitoIdentityServiceProvider.{Cognito_Client_Id}.{Cognito_Username}.userData",
                "The userData is a part of the session object that Cognito returns when a user successfully logs in. It typically contains information about the authenticated user, such as MFA setting, name, username, email address and etc.",
                "Persistent",
            ],
        },
    },
    {
        table: {
            headers: ["Cookie", "Description", "Persistent/ Session"],
            rows: [
                "CognitoIdentityServiceProvider.{Cognito_Client_Id}.{Cognito_Username}.LastAuthUser",
                "Amazon Cognito uses this key to remember the user who last signed in successfully. This is useful for scenarios where you want to remember the user's session even after they close the browser, or if you want to automatically sign the user in when they return to your application.",
                "Persistent",
            ],
        },
    },
    {
        table: {
            headers: ["Cookie", "Description", "Persistent/ Session"],
            rows: [
                "amplify-signin-with-hostedUI",
                "AWS Amplify provides a hosted UI that allows for authentication to your application allowing users to sign up and sign in.",
                "Persistent",
            ],
        },
    },
    {
        heading: "Support Portal",
        content:
            "On our Support Portal we utilises the following mandatory cookies.",
    },
    {
        table: {
            headers: ["Cookie", "Description"],
            rows: [
                "BIGipServerpool_baringaprode",
                "The BigIP cookie is used for load-balancing decisions and absolutely no customer data is disclosed.",
            ],
        },
    },
    {
        table: {
            headers: ["Cookie", "Description"],
            rows: [
                "glide_user_activity",
                "The glide_user_activity prevents the log-out of an active user who did not opt-in to the 'Remember Me' option. It renews periodically if the user is active during the session. Its presence is to detect if there is any activity being performed on the users' end so that the session won't lock out the user during an active session. It will help the server to refresh the session.",
            ],
        },
    },
    {
        table: {
            headers: ["Cookie", "Description"],
            rows: [
                "glide_user_route",
                "The glide_user_route cookie defines which application server (or node) in the cluster you are going to, so it remains consistent unless otherwise directed/redirected from the load balancer. Briefly, it manages node persistence.",
            ],
        },
    },
    {
        table: {
            headers: [
                "Cookie",
                "Description",
                "Name",
                "Type",
                "Value",
                "Purpose",
            ],
            rows: [
                "glide_session_store",
                "The 'glide_session_store' was added to preserve the session when moving customers from one node to another. Having it enabled will make sure their users are not logged out in case we fail them over from one data center to another. However, it is not recommended but you can disable it by adding the following property:",
                "glide.session_store.enabled",
                "True / False",
                "False",
                "The purpose of the glide_session_store cookie is for the user to recover some of the session states when the main session has been lost, e.g. when the user has been redirected to an instance different from the instance on which the session was established. Whenever a new user session is established, the glide_session_store cookie is updated. Whenever the navigation history changes, the data associated with the glide_session_store cookie is updated. The glide_session_store cookie is not used for authentication and cannot be used to authenticate. It is used only for the partial restoration of the state. Other cookies, however, such as the glide_user_activity cookie, do play a role in authentication.",
            ],
        },
    },
    {
        table: {
            headers: ["Cookie", "Description"],
            rows: [
                "glide_sso_id",
                "The 'glide_sso_id' cookie contains the sys_id of the respective Identity Provider record that the browser client has been associated with. Most of the time, that cookie value is the same as the 'glide.authenticate.sso.redirect.idp' property, however, it can be a different value if customers have different IdPs for various users on their instance. As it is simply an identifier of the IdP and not useful to an attacker, there are no plans to modify the attributes of this cookie.",
            ],
        },
    },
    {
        table: {
            headers: ["Cookie", "Description"],
            rows: [
                "JSESSIONID",
                "The 'JSESSIONID' cookie is a session cookie created by the application when the user first logs into the application and is created by the underlying server to maintain the session attributes of the user session.",
            ],
        },
    },
    {
        table: {
            headers: ["Cookie", "Description"],
            rows: [
                "__CJ_g_startTime",
                "The '__CJ_g_startTime' cookie is set by certain UI pages to mark the loading start time of a page and does not contain any sensitive information.",
            ],
        },
    },
    {
        table: {
            headers: ["Cookie", "Description"],
            rows: [
                "glide_node_id_for_js",
                "glide_node_id_for_js is a non-HttpOnly cookie, that is used internally to support weighted load balancing features. It is used to migrate a web socket connection to the same node as the HTTP connection whenever HTTP connection is migrated to the new node. It doesn’t contain any sensitive information and is hashed using SHA-256.",
            ],
        },
    },
    {
        heading: "Performance",
        content:
            "Performance cookies collect information about how visitors use a website, for instance, which pages visitors go to most often and if they get error messages from web pages. These cookies do not collect information that identifies a visitor. Any information collected by these cookies is anonymous.",
    },
    {
        heading: "Functionality",
        content:
            "Functionality cookies allow the website to remember choices you make (such as your log in details) and customised preference settings (e.g. text size). They also enable enhanced, more personal features, e.g. a website may be able to provide you with local weather reports or traffic news by using a cookie to remember which region you are in. These cookies are also used to provide services you have asked for such as watching a video. Information collected by 'functionality' cookies may or may not be anonymised, but they cannot track your browsing activity on other websites.",
    },
    {
        heading: "Targeting",
        content:
            "These cookies collect information about your browsing habits to make advertising relevant to you and your interests. These cookies collect the most information about users.",
    },
    {
        heading: "Contact Information",
        content:
            "If you have any questions about our Cookies Policy, please contact us at data@energynetworks.org.",
    },
]
